import React from "react";
import "./SubjectControlsMenu.css";
import { centerIcon, middleIcon } from "../../../../icons/assets";
import { useEditorStore } from "../../../../state/editorStore";

const SubjectControlsMenu = ({ onAlign = () => {}, beforeAlign = null }) => {
  const selectedLayerId = useEditorStore((s) => s.selectedLayerId);
  const layers = useEditorStore((s) => s.layers);

  const titleLabel = (() => {
    if (
      selectedLayerId &&
      selectedLayerId !== "object" &&
      selectedLayerId !== "background"
    ) {
      const imageLayer = layers.find(
        (l) => l.id === selectedLayerId && l.type === "image"
      );
      if (imageLayer?.label?.trim()) return imageLayer.label.trim();
    }
    const objectLayer = layers.find((l) => l.id === "object");
    const objectLabel = objectLayer?.label?.trim();
    return objectLabel || "Object";
  })();

  const handleAlignment = (mode) => {
    onAlign(mode);
  };

  return (
    <div className="subject-control-menu-container">
      <div className="subject-header">
        <h3 className="subject-header-title">{titleLabel}</h3>
      </div>

      {beforeAlign}

      <div className="subject-align-section">
        <p className="subject-section-label">Align</p>
        <div className="subject-alignment-buttons">
          <button
            className="subject-align-btn"
            onClick={() => handleAlignment("center")}
          >
            <img src={centerIcon} alt="" className="align-icon" />
            Center
          </button>
          <button
            className="subject-align-btn"
            onClick={() => handleAlignment("middle")}
          >
            <img src={middleIcon} alt="" className="align-icon" />
            Middle
          </button>
        </div>

        <div className="subject-alignment-buttons subject-alignment-extra">
          <button
            className="subject-align-btn subject-align-btn--icon-only"
            onClick={() => handleAlignment("left")}
            title="Left"
          >
            <span className="align-icon-text">←</span>
          </button>
          <button
            className="subject-align-btn subject-align-btn--icon-only"
            onClick={() => handleAlignment("right")}
            title="Right"
          >
            <span className="align-icon-text">→</span>
          </button>
          <button
            className="subject-align-btn subject-align-btn--icon-only"
            onClick={() => handleAlignment("top")}
            title="Top"
          >
            <span className="align-icon-text">↑</span>
          </button>
          <button
            className="subject-align-btn subject-align-btn--icon-only"
            onClick={() => handleAlignment("bottom")}
            title="Bottom"
          >
            <span className="align-icon-text">↓</span>
          </button>
        </div>

        <div className="subject-alignment-buttons subject-alignment-extra">
          <button
            className="subject-align-btn subject-align-btn--icon-only"
            onClick={() => handleAlignment("topLeft")}
            title="Top Left"
          >
            <span className="align-icon-text">↖</span>
          </button>
          <button
            className="subject-align-btn subject-align-btn--icon-only"
            onClick={() => handleAlignment("topRight")}
            title="Top Right"
          >
            <span className="align-icon-text">↗</span>
          </button>
          <button
            className="subject-align-btn subject-align-btn--icon-only"
            onClick={() => handleAlignment("bottomLeft")}
            title="Bottom Left"
          >
            <span className="align-icon-text">↙</span>
          </button>
          <button
            className="subject-align-btn subject-align-btn--icon-only"
            onClick={() => handleAlignment("bottomRight")}
            title="Bottom Right"
          >
            <span className="align-icon-text">↘</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubjectControlsMenu;
